/**
 * @file: AiWorkshopToolsSection.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { AiSectionHeader } from './AiSectionHeader';
import { AiWorkshopTile } from './AiWorkshopTile';
import { AiWorkshopToolKind, AiWorkshopTools } from './useAiWorkshopTools';

/** The AI edition's workshop tools, with their trial's end. */
export const AiWorkshopToolsSection = memo(
  ({
    workshop,
    onPress,
  }: {
    workshop: AiWorkshopTools;
    onPress: (kind: AiWorkshopToolKind) => void;
  }) => {
    const styles = useStyles();
    return (
      <View>
        <AiSectionHeader
          title="您的门店增长引擎"
          trialEndsAt={workshop.trialEndsAt}
        />
        <View style={styles.grid}>
          {workshop.tools.map(tool => (
            <AiWorkshopTile
              key={tool.kind}
              tool={tool}
              onPress={() => onPress(tool.kind)}
            />
          ))}
        </View>
      </View>
    );
  },
);

function useStyles() {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () =>
      StyleSheet.create({
        grid: { flexDirection: 'row', flexWrap: 'wrap', gap: rpx(10) },
      }),
    [rpx],
  );
}
